import React from "react";
import { useLanguage } from "../LanguageContext";

import "../../assets/css/hero.css";
import "../../assets/css/font.css";

function Hero() {
  const { t } = useLanguage();

  return (
    <section className="hero container">
      <span className="hero-status mono">
        <span className="hero-status-dot" aria-hidden="true" />
        {t.hero.status}
      </span>
      <h1 className="hero-title">{t.hero.title}</h1>
      <p className="hero-description">{t.hero.description}</p>
      <div className="hero-actions">
        <a href="#projects" className="button button-primary">
          {t.hero.ctaWork}
        </a>
        <a href="#contact" className="button button-secondary">
          {t.hero.ctaContact}
        </a>
      </div>
    </section>
  );
}

export default Hero;
